.button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: var(--h-ctl);
  padding: 0 12px;
  border: 1px solid var(--line);
  border-radius: var(--radius-ctl);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  cursor: pointer;
}

.button:hover {
  background: var(--panel-2);
}

.button:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.group + .group {
  margin-top: 20px;
}

.heading {
  margin: 0 0 10px;
  font-size: var(--t-body);
}
